export default "__VITE_ASSET__De5wJb6C__"